<script>
    import DataTable, {Body, Head, Row, Cell} from "@smui/data-table";

    import Currency from "../component/Currency.svelte";

    /** @type (array) result array from API */
    export let result = undefined;

    function getValue(result, key, period = "monthly") {
        let periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
        return result[key] * periodFactor;
    }

    /*let same = false;
    const before = getValue(result, "netToPayBeforePAS");
    const after = getValue(result, "netToPayAfterPAS");

    if(before === after){
        same = true;
    }*/
</script>
<DataTable table$aria-label="slideyear-one" style="width: 100%;">
    <Head>
        <Row>
            <Cell as="th" colspan="2" style="text-align: center"><span class="orange">Annuel</span></Cell>
        </Row>
    </Head>
    <Body>
    <Row style="height: 25px;">
        <Cell>TJM</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "dailyRate", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Facturation</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "invoiceAmount", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Brut</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "totalBaseGross", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Net<span class="super">*</span> + Frais</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "netToPayBeforePAS", "yearly")}/>
        </Cell>
    </Row>
    <!--{#if privateVersion}-->
    <Row style="height: 25px;">
        <Cell>PAS</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "pasAmount", "yearly")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Net<span class="super">**</span> + Frais</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "netToPayAfterPAS", "yearly")}/>
        </Cell>
    </Row>
    <!--{/if}-->
    </Body>
</DataTable>
